import React, { useEffect, useCallback, useMemo } from 'react'
import { LockedGrid, Grid as UnlockedGrid } from '@sencha/ext-modern'

import { useInstData, useEventHandler } from 'tyan/public/hooks'
import { getModel, renderColumn, getViewModel, handleItemContextMenu, genContextMenu } from '../column'
import { cloneDeep } from 'lodash'

const MyGrid = props => {
	const { me, setState, me: { state: { store } } } = useInstData(props)
	const { config, config: { onDoubleTap, columns }, list, that, forViewModel } = props
	const contextmenu = useMemo(() => config && (config.contextmenu || columns && genContextMenu(columns)), [config])

	useEffect(() => {
		setState({
			store: new Ext.data.Store({
				model: forViewModel ? getModel() : getModel(config.columns),
				data: list && cloneDeep(list) || [],
			})
		})
	}, [columns])
	useEffect(() => {
		store && (store.setData(list && cloneDeep(list) || []), setState({}))
	}, [list])

	const listeners = {
		childDoubleTap: useEventHandler(useCallback(({ }, r) => {
			onDoubleTap && onDoubleTap(r.child.getRecord().data, r.child.getRecord())
		}, [onDoubleTap]))
	}
	contextmenu && (listeners.childContextMenu = listeners.childLongPress = (grid, { record, event }) => handleItemContextMenu(contextmenu, grid, record, event, me))

	const gridOption = { itemConfig: { viewModel: forViewModel ? getViewModel(columns || []) : {} } }

	const Grid = Ext.os.is.Phone ? UnlockedGrid : LockedGrid
	Grid == 'LockedGrid' ? (gridOption.gridDefaults = { listeners }) : gridOption.listeners = listeners

	return store ? <Grid flex={1} store={store} {...gridOption} >
		{columns && columns.map((column, key) => renderColumn(column, key/* `${currentTask}${column._text}` */, that, forViewModel))}
	</Grid> : null
}

export default MyGrid